const australia = [
    { name: "New South Wales", code: "NSW" },
    { name: "Victoria", code: "VIC" },
    { name: "Queensland", code: "QLD" },
    { name: "Western Australia", code: "WA" },
    { name: "South Australia", code: "SA" },
    { name: "Tasmania", code: "TAS" },
    { name: "Australian Capital Territory", code: "ACT" },
    { name: "Northern Territory", code: "NT" }
  ];
  export default australia;